import { EmailCustomization } from '../emailCustomization';

export enum TeamFormStatus {
  Open = 'open',
  Closed = 'closed'
}

export class TeamFormRecipient {
  isAnonymous: boolean;
  anonymousId: string;
  email: string;
  personId: string;
  fullName: string;
  secureLinkId: string;
  isCompleted: boolean;
  requestUri: string;
  seatId: string;

  public static parse(data: any): TeamFormRecipient {
    if (!data) return null;

    let teamFormRecipient = new TeamFormRecipient();
    Object.assign(teamFormRecipient, data);

    return teamFormRecipient;
  }
}

export class TeamFormDetail {
  id: string;
  title: string;
  templateId: string;
  deadline: Date;
  introduction: string;
  confirmation: string;
  recipients: TeamFormRecipient[] = [];
  hasExpired: boolean;
  createdOn: Date;
  totalSent: number;
  totalCompleted: number;
  emailMetadata: EmailCustomization[];

  constructor(teamFormDetail: any = null) {
    return TeamFormDetail.parse(teamFormDetail);
  }

  public static parse(data: any): TeamFormDetail {
    if (!data) return null;

    let teamFormDetail = new TeamFormDetail();
    Object.assign(teamFormDetail, data);

    return teamFormDetail;
  }
}
